(function() {
  define('bazemont/shared/sortableTableHead',['angular'], function() {
    'use strict';
    return angular.module('bazemontSortableTableHead', []).component('bazemontSortableTableHead', {
      templateUrl: '/assets/javascripts/bazemont/shared/sortableTableHead.html',
      bindings: {
        title: '@',
        property: '=',
        value: '@',
        arrayValue: '<',
        asc: '<'
      },
      controller: [
        '$scope', function($scope) {
          var vm;
          vm = this;
          vm.$onInit = function() {
            return vm.currentValue = vm.value || vm.arrayValue;
          };
          vm.getIconClass = function() {
            var iconClass;
            iconClass = 'fa fa-arrow-circle-';
            if (vm.property === vm.currentValue) {
              iconClass += 'o-';
            }
            return iconClass += vm.asc ? 'up' : 'down';
          };
        }
      ]
    });
  });

}).call(this);

//# sourceMappingURL=sortableTableHead.js.map
;
